var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    initialized: false,
    firstName: undefined,
    lastName: undefined,
    tel: undefined,
    dob: undefined,
    ssn4: undefined,
    ssn9: undefined,
};
export var piiDataSlice = createSlice({
    name: 'piiData',
    initialState: initialState,
    reducers: {
        setFirstName: function (state, action) { return (__assign(__assign({}, state), { initialized: true, firstName: action.payload })); },
        setLastName: function (state, action) { return (__assign(__assign({}, state), { initialized: true, lastName: action.payload })); },
        setDob: function (state, action) { return (__assign(__assign({}, state), { initialized: true, dob: action.payload })); },
        setSSN4: function (state, action) { return (__assign(__assign({}, state), { initialized: true, ssn4: action.payload })); },
        setSSN9: function (state, action) { return (__assign(__assign({}, state), { initialized: true, ssn9: action.payload })); },
        setTel: function (state, action) { return (__assign(__assign({}, state), { initialized: true, tel: action.payload })); },
    },
});
export var setFirstName = (_a = piiDataSlice.actions, _a.setFirstName), setLastName = _a.setLastName, setDob = _a.setDob, setSSN4 = _a.setSSN4, setSSN9 = _a.setSSN9, setTel = _a.setTel;
export var selectFirstName = function (state) { return state.piiData.firstName; };
export var selectLastName = function (state) { return state.piiData.lastName; };
export var selectDob = function (state) { return state.piiData.dob; };
export var selectSSN4 = function (state) { return state.piiData.ssn4; };
export var selectSSN9 = function (state) { return state.piiData.ssn9; };
export var selectTel = function (state) { return state.piiData.tel; };
export default piiDataSlice.reducer;
